/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListinoMangimiDettaglioCreateDTO
 */
export interface ListinoMangimiDettaglioCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoMangimiDettaglioCreateDTO
     */
    idTipoMangime?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListinoMangimiDettaglioCreateDTO
     */
    inizioValidita?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListinoMangimiDettaglioCreateDTO
     */
    valore?: number;
}

/**
 * Check if a given object implements the ListinoMangimiDettaglioCreateDTO interface.
 */
export function instanceOfListinoMangimiDettaglioCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoMangimiDettaglioCreateDTOFromJSON(json: any): ListinoMangimiDettaglioCreateDTO {
    return ListinoMangimiDettaglioCreateDTOFromJSONTyped(json, false);
}

export function ListinoMangimiDettaglioCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoMangimiDettaglioCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idTipoMangime': !exists(json, 'idTipoMangime') ? undefined : json['idTipoMangime'],
        'inizioValidita': !exists(json, 'inizioValidita') ? undefined : (new Date(json['inizioValidita'])),
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
    };
}

export function ListinoMangimiDettaglioCreateDTOToJSON(value?: ListinoMangimiDettaglioCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idTipoMangime': value.idTipoMangime,
        'inizioValidita': value.inizioValidita === undefined ? undefined : (value.inizioValidita.toISOString()),
        'valore': value.valore,
    };
}

